import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../providers/auth-context';
import { ErrorState } from '../components/ui';

/** Garde de session : redirige vers /login tant que l'admin n'est pas authentifié. */
export function RequireAuth({ children }: { children: ReactNode }): JSX.Element {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    return (
      <div
        style={{
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#8A95A3',
          fontSize: 14,
        }}
        aria-busy="true"
      >
        Chargement de la session…
      </div>
    );
  }

  if (status !== 'authenticated') {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return <>{children}</>;
}

/** Garde RBAC d'écran. La règle est rejouée côté use case et côté API. */
export function RequireSuperAdmin({ children }: { children: ReactNode }): JSX.Element {
  const { isSuperAdmin } = useAuth();
  if (!isSuperAdmin) {
    return (
      <ErrorState
        status={403}
        message="Seul un super-admin peut accéder à cet écran."
      />
    );
  }
  return <>{children}</>;
}
